import { z } from 'zod';

export const TimestampSchema = z.number().int().positive();

export const HexColorSchema = z.string().regex(/^#[0-9A-Fa-f]{6}$/);

export const BaseEntitySchema = z.object({
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
  deletedAt: TimestampSchema.optional(),
});
